import { useNavigate } from 'react-router-dom';
import { ProductForm } from './ProductFormShared';

export default function ProductRegister() {
  const navigate = useNavigate();

  const handleSave = () => {
    navigate('/products');
  };

  const handleCancel = () => {
    navigate('/products');
  };

  return (
    <div style={{ minWidth: '1100px', maxWidth: '1100px' }}>
      <ProductForm product={null} onSave={handleSave} onCancel={handleCancel} />
    </div>
  );
}
